import React from 'react';
import { Link, useParams } from 'react-router-dom';
import '../LegalPages.css'; // A shared CSS file for styling
import { useCookieConsent } from '../../../context/CookieConsentContext';

const CookiePolicy = () => {
  const { lang } = useParams();
  const { openSettings } = useCookieConsent();
  return (
    <div className="legal-page-container">
      <div className="legal-content">
        <h1>Cookie Policy</h1>
        <p>Last updated: October 11, 2025</p>
        <p>This Cookie Policy explains how we use cookies and similar technologies to recognize you when you visit our website. It explains what these technologies are and why we use them, as well as your rights to control our use of them.</p>
        <p>SeegSoog.com is operated by Log-Inn the Smart Home Ltd., Company Registration Number 514147305, Israel. This Cookie Policy applies to the operations of Log-Inn the Smart Home Ltd. on SeegSoog.com.</p>

        <h2>What are cookies?</h2>
        <p>A cookie is a small data file that is placed on your device when you visit a website. Cookies are widely used by website owners in order to make their websites work, or to work more efficiently, as well as to provide reporting information.</p>

        <h2>Why do we use cookies?</h2>
        <p>
          We use first-party and third-party cookies for several reasons. Some cookies are required for technical reasons in order for our Website to operate, and we refer to these as "essential" or "strictly necessary" cookies. Other cookies also enable
          us to track and target the interests of our users to enhance the experience on our Online Properties. Third parties serve cookies through our Website for advertising, analytics, and other purposes. This is described in more detail below.
        </p>

        <h2>What types of cookies do we use?</h2>

        <h3>Essential Website Cookies</h3>
        <p>
          These cookies are strictly necessary to provide you with services available through our Website and to use some of its features, such as access to secure areas. Because these cookies are strictly necessary to deliver the Website to you, you
          cannot refuse them without impacting how our Website functions.
        </p>
        <ul>
          <li>
            <strong>connect.sid:</strong> This is the main session cookie used by our application to identify a user's session after they log in. It is a "strictly necessary" cookie.
          </li>
          <li>
            <strong>trusted_device:</strong> This cookie is set when you successfully use the "Trust this device" option during two-factor authentication. It remembers your device to bypass 2FA on future logins.
          </li>
        </ul>

        <h3>Performance and Functionality Cookies</h3>
        <p>These cookies are used to enhance the performance and functionality of our Website but are non-essential to their use. However, without these cookies, certain functionality may become unavailable.</p>
        <ul>
          <li>
            <strong>i18next / site_language:</strong> These cookies are used to remember your preferred language setting so that the site is displayed in your chosen language on subsequent visits.
          </li>
        </ul>

        <h3>Analytics and Customization Cookies</h3>
        <p>These cookies collect information that is used either in aggregate form to help us understand how our Website is being used or how effective our marketing campaigns are, or to help us customize our Website for you.</p>
        <ul>
          <li>
            <strong>Firebase/Google Analytics:</strong> We use Firebase and Google Analytics to collect information about how visitors use our site. The cookies collect information in an anonymous form, including the number of visitors to the site, where
            visitors have come to the site from and the pages they visited. This information is used to compile reports and to help us improve the site. Google's privacy policy can be found here:{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
              https://policies.google.com/privacy
            </a>
          </li>
        </ul>

        <h3>Other tracking technologies</h3>
        <p>
          We may also use other, similar technologies from time to time, like web beacons (sometimes called "tracking pixels" or "clear gifs"). These are tiny graphics files that contain a unique identifier that enable us to recognize when someone has
          visited our Website or opened an e-mail that we have sent them. This allows us, for example, to monitor the traffic patterns of users from one page within our Website to another, to deliver or communicate with cookies, to understand whether you
          have come to our Website from an online advertisement displayed on a third-party website, to improve site performance, and to measure the success of e-mail marketing campaigns. In many instances, these technologies are reliant on cookies to
          function properly, and so declining cookies will impair their functioning.
        </p>

        <h2>How can I control cookies?</h2>
        <p>You have the right to decide whether to accept or reject non-essential cookies. When you first visit our site, you will be presented with a cookie consent banner where you can make your choice.</p>
        <p>You can change your cookie preferences at any time by clicking the button below. This will reopen the consent modal, allowing you to change your settings or withdraw your consent.</p>
        <p>
          <button className="link-button" onClick={openSettings}>
            Manage Cookie Settings
          </button>
        </p>
        <p>
          Additionally, you can set or amend your web browser controls to accept or refuse cookies. If you choose to reject cookies through your browser, you may still use our website, though your access to some functionality and areas may be restricted.
          As the means by which you can refuse cookies through your web browser controls vary from browser to browser, you should visit your browser's help menu for more information.
        </p>

        <h2>Changes to this Cookie Policy</h2>
        <p>
          We may update this Cookie Policy from time to time in order to reflect, for example, changes to the cookies we use or for other operational, legal or regulatory reasons. Please therefore re-visit this Cookie Policy regularly to stay informed
          about our use of cookies and related technologies.
        </p>

        <h2>Where can I get further information?</h2>
        <p>
          If you have any questions about our use of cookies or other technologies, please <Link to={`/${lang}/contact-us`}>contact us</Link>.
        </p>
      </div>
    </div>
  );
};

export default CookiePolicy;
